import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import Logo from '../../components/Logo';
import Footer from '../../components/Layout/Footer';

// Assets
import logo from '../../assets/images/logos/legacy_logo.png';
import background from '../../assets/images/legacy_background.jpg';
import { brandColors, fonts } from '../../styles/variables';
import Title from '../../components/Title';
import Hyperlink from '../../components/Hyperlink';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;

  .footer {
    position: absolute;
    bottom: 0;
  }
`;

const BackgroundImage = styled.div`
  background: url(${background}) no-repeat 50%;
  background-size: cover;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: -1;
`;

const ContentWrapper = styled.div`
  padding-top: 103px;
  z-index: 1;
  padding-bottom: 100px;
`;

const LogoPosition = styled.div`
  margin: 0 auto;
  width: 113px;

  .logo {
    padding: 0;
  }
`;

const ContentBlock = styled.div`
  min-height: 375px;
  max-width: 660px;
  width: 90%;
  text-align: center;
  margin: 46px auto 0;
  box-sizing: border-box;
  background-color: ${brandColors.white};
  padding: 32px 20px;

  p {
    color: ${brandColors.blue};
    font-size: 18px;
    line-height: 38px;
    letter-spacing: 1px;
    font-style: italic;
    font-family: ${fonts.athelas};
  }

  .title {
    h2 {
      max-width: 620px;
    }
  }
`;

const NotFound = () => (
  <Wrapper>
    <BackgroundImage />
    <ContentWrapper>
      <LogoPosition>
        <Logo className="logo" logo={logo} />
      </LogoPosition>
      <ContentBlock>
        <p>Uh-oh....</p>
        <Title className="title" primary={false}>
          The page you are looking for doesn&apos;t exist.<br />
          <br />
          <Hyperlink
            color={brandColors.orange}
            linkName="Return to our homepage"
            linkAddress="/"
            constantLink
            internalLink
          />
        </Title>
        <p>
          The Printworks, 7 Blake Mews,<br />Kew, London, TW9 3GA<br />
          <Hyperlink
            color={brandColors.orange}
            originalColor={brandColors.blue}
            linkName="02083347860"
            linkAddress="tel:02083347860"
          />
        </p>
      </ContentBlock>
      <Footer className="footer" />
    </ContentWrapper>
  </Wrapper>
);

export default connect()(NotFound);



// WEBPACK FOOTER //
// ./src/pages/404/index.jsx